import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, PartyPopper } from 'lucide-react';

export default function ArtikelEidPartyPlanen() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Eid Party planen: Der komplette Guide für ein unvergessliches Fest</h1>
          <p className="text-lg text-white/80 leading-relaxed">Von der Einladung bis zur Deko, vom Essen bis zu den Spielen – so planst du die perfekte Eid-Feier für Familie und Freunde.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Eid ist die Zeit zum Feiern! Ob du eine kleine Familienfeier oder ein großes Fest mit Freunden und Nachbarn planst – mit der richtigen Vorbereitung wird deine Eid-Party ein unvergessliches Erlebnis für Groß und Klein.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><PartyPopper className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Planung & Vorbereitung</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">4 Wochen vorher: Gästeliste & Einladungen</h4>
                <p className="text-sm text-[#4B5563]">Erstelle eine Gästeliste und verschicke Einladungen. Digitale Einladungen mit WhatsApp sind ok, aber gedruckte "Eid Mubarak"-Karten sind etwas Besonderes. Vergiss nicht, nach Allergien und Diätwünschen zu fragen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">2 Wochen vorher: Menü & Einkauf</h4>
                <p className="text-sm text-[#4B5563]">Plane dein Menü und bestelle spezielle Zutaten rechtzeitig. Tipp: Viele Gerichte können vorgekocht und eingefroren werden. Bestelle auch die Dekoration und Geschenk-Tüten.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">1 Woche vorher: Deko & letzte Details</h4>
                <p className="text-sm text-[#4B5563]">Dekoriere dein Zuhause, bereite Goodie-Bags für Kinder vor und stelle einen Zeitplan für den Tag auf. Denke an Musik (Nasheeds), Spiele und einen Bereich für das Gebet.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Am Tag davor: Kochen & Aufbauen</h4>
                <p className="text-sm text-[#4B5563]">Vorkochbare Gerichte fertigstellen, Tisch eindecken, Geschenk-Bereich einrichten. Am Eid-Morgen sollte nur noch Aufwärmen und Anrichten nötig sein.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Dekoration</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Farbschema wählen</h4>
                <p className="text-sm text-[#4B5563]">Beliebte Farbkombinationen: Gold & Weiß (elegant), Grün & Gold (traditionell), Pastell (modern), Bunt (für Kinderpartys). Ziehe das Farbschema durch Tischdecken, Servietten, Ballons und Girlanden durch.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Must-Have Deko-Elemente</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>• "Eid Mubarak"-Banner oder Lichterkette</li>
                  <li>• Mond- und Stern-Girlanden</li>
                  <li>• Laternen (echte Kerzen oder LED)</li>
                  <li>• Luftballons in Gold/Weiß/Grün</li>
                  <li>• Dattel-Schalen als Tischdeko</li>
                  <li>• Frische Blumen oder Eukalyptuszweige</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Fotowand</h4>
                <p className="text-sm text-[#4B5563]">Richte eine Fotowand ein mit einem "Eid Mubarak"-Hintergrund, Requisiten und goldenen Ballons. Perfekt für Instagram und Familienfotos!</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Essen & Getränke</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Buffet oder Menü?</h4>
                <p className="text-sm text-[#4B5563]">Für große Gruppen eignet sich ein Buffet am besten. Bei kleineren Runden ist ein serviertes Menü persönlicher. Tipp: Ein "Potluck" (jeder bringt etwas mit) entlastet den Gastgeber und bringt Vielfalt.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Buffet-Ideen</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>• Hauptgerichte: Biryani, Kabsa, gegrilltes Lamm</li>
                  <li>• Beilagen: Hummus, Fattoush, Fladenbrot</li>
                  <li>• Süßes: Baklava, Maamoul, Kuchen</li>
                  <li>• Getränke: Minztee, Jallab, Säfte</li>
                  <li>• Kinder-Ecke: Mini-Sandwiches, Obstspieße, Cake Pops</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Spiele & Aktivitäten</h2>
            <div className="grid sm:grid-cols-2 gap-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für Kinder</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>• Eid-Schatzsuche</li>
                  <li>• Bastelstation (Karten, Laternen)</li>
                  <li>• Eid-Quiz</li>
                  <li>• Hüpfburg (im Garten)</li>
                  <li>• Kinderschminken</li>
                </ul>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Für Erwachsene</h4>
                <ul className="text-sm text-[#4B5563] space-y-1">
                  <li>• Islamisches Wissensquiz</li>
                  <li>• Henna-Station</li>
                  <li>• Foto-Challenge</li>
                  <li>• Geschichten erzählen</li>
                  <li>• Karaoke (Nasheeds)</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Goodie-Bags & Gastgeschenke</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Für Kinder:</strong> Süßigkeiten, kleine Spielzeuge, Sticker, Eidi-Umschlag, Mini-Malbuch</li>
                <li><strong>Für Erwachsene:</strong> Selbstgemachte Kekse, Datteln, Duftkerze, "Eid Mubarak"-Karte</li>
                <li><strong>Verpackung:</strong> Organza-Beutel, kleine Geschenkboxen oder Papiertüten mit Eid-Aufkleber</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Eine Eid-Party muss nicht perfekt sein – sie muss von Herzen kommen. Ob groß oder klein, aufwändig oder schlicht: Die Freude des Festes liegt im Zusammensein, im Lachen und im Teilen. Plan ein bisschen, improvisiere viel und genieße jeden Moment!</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak!</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/eid-deko-ideen" className="text-[#4A5D4F] hover:underline">→ Eid Deko Ideen für Zuhause</Link></li>
              <li><Link to="/ratgeber/eid-spiele-quiz" className="text-[#4A5D4F] hover:underline">→ Eid Spiele und Quiz für die Familie</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
